import { render, staticRenderFns } from "./float-dingyue.vue?vue&type=template&id=1987943d&"
import script from "./float-dingyue.vue?vue&type=script&lang=js&"
export * from "./float-dingyue.vue?vue&type=script&lang=js&"
import style0 from "./float-dingyue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports